import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { useState } from "react";
export type TabData = {
  label: string;
  labelIcon?: JSX.Element;
  content: JSX.Element;
};
export interface TabsDataProps {
  tabsData: TabData[];
  index?: number; // initial index
  activeIndex?: number; // controlled index from parent
  onTabChange?: (index: number) => void; // callback when tab changes
}

const CustomTabs = (props: TabsDataProps) => {
  const { tabsData, index, activeIndex, onTabChange } = props;
  const [internalIndex, setInternalIndex] = useState(index ?? 0);

  // If parent provides activeIndex, use it. Otherwise, use internal state.
  const tabIndex = activeIndex !== undefined ? activeIndex : internalIndex;

  const handleChange = (newIndex: number) => {
    if (onTabChange) {
      onTabChange(newIndex);
    } else {
      setInternalIndex(newIndex);
    }
  };

  return (
    <Tabs
      isFitted
      isLazy
      variant="soft-rounded"
      colorScheme="blue"
      className="p-4"
      index={tabIndex}
      onChange={handleChange}
    >
      <TabList className="overflow-x-scroll border-b py-2">
        {tabsData.map((tab: TabData, index) => (
          <Tab
            key={index}
            className="whitespace-nowrap !px-3 !py-2 sm:!text-xs md:!text-sm 4xl:!text-lg"
            _selected={{ bg: "blue.500", color: "white" }}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabPanels className="custom-tab-panel !h-[400px]">
        {tabsData.map((tab: TabData, index) => (
          <TabPanel p={4} key={index}>
            {tab.content}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default CustomTabs;
